import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-34bfe3ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "course__new_contents"
}
const _hoisted_2 = { class: "course__information" }
const _hoisted_3 = { class: "b-course__information" }
const _hoisted_4 = { class: "course__information--title highlighted-text bold" }
const _hoisted_5 = {
  key: 0,
  class: "inactive"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "flag" }, "Online", -1))
const _hoisted_7 = { class: "course__description" }
const _hoisted_8 = { class: "course__information--progress" }
const _hoisted_9 = { class: "b-course__information--time-watched" }
const _hoisted_10 = { class: "course__information--time-watched" }
const _hoisted_11 = {
  key: 0,
  class: "course__rating"
}
const _hoisted_12 = { class: "b-course__information--percentage" }
const _hoisted_13 = { class: "course__information--percentage" }
const _hoisted_14 = { class: "highlighted-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "course__img",
      style: _normalizeStyle(
      `
    background: linear-gradient(
  101.39deg,
  rgba(40, 55, 135, 0.38) 0%,
  rgba(35, 125, 174, 0.38) 98.82%
  ), url(${_ctx.training.imageURL}) no-repeat center / cover;`
    )
    }, [
      (_ctx.training.hasNewContent)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1))
        : _createCommentVNode("", true)
    ], 4),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, [
          _createTextVNode(_toDisplayString(_ctx.training.title || _ctx.training.name) + " ", 1),
          (_ctx.isInactive(_ctx.training))
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Inativo"))
            : _createCommentVNode("", true)
        ]),
        (_ctx.training.progress === 100 && _ctx.training.haveCertification)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.openCertificate(_ctx.training.id)), ["prevent"]))
            }, " visualizar certificado "))
          : _createCommentVNode("", true)
      ]),
      _hoisted_6,
      _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.training.description), 1),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.formattedDuration(_ctx.training.duration)), 1),
          (_ctx.training.rating)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("span", null, _toDisplayString(_ctx.training.rating), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("p", _hoisted_13, [
            _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.training.progress) + "% concluído", 1)
          ])
        ])
      ])
    ])
  ], 64))
}